import { IAddressContact } from './address.interface';

export enum EAddressVerifiedStatus {
  SUCCESS = 'Address validated successfully',
  FAILED = 'Address validation failed',
  WARNING = 'Address validation warning',
  NOT_VERIFIED = 'Address not verified',
  NOT_FOUND = 'Address not found',
}
